import React from "react";
import { AdminPanelSettings, Home } from "@mui/icons-material";
import {
	ListItemIcon,
	ListItemIconProps,
	MenuItem,
	Typography,
	styled,
} from "@mui/material";
import { SignOutItem } from "../PageLayout/SignOutItem";
import { useNavigate } from "react-router-dom";
import { UserRole } from "../../context/ConfigContext/types";
import { useConfig } from "../../context/ConfigContext";
import { routes } from "../../router/routes";
import styles from "./NavBar.module.css";
import GoogleTranslate from "../GoogleTranslate";
import { useClientAccessContext } from "../../context/ClientAccessContext";
import { GlobalUserRole } from "../../context/ClientAccessContext/types";
import BarChartIcon from "@mui/icons-material/BarChart";
import { clientsWithReport } from "../../router/AuthenticatedRoutes";

export const CustomListIcon = styled(ListItemIcon)<ListItemIconProps>(
	({ theme }) => ({
		color: "#ffffff",
	})
);

const ExpandedNavItems = ({ isAuthenticated }) => {
	const { selectedClient, userWithClients } = useClientAccessContext();
	const { user, selectedTopic } = useConfig();
	const navigate = useNavigate();
	return (
		<div className={styles.expandedNavItems}>
			{isAuthenticated ? (
				<div>
					<MenuItem onClick={() => navigate(routes.overview)}>
						<CustomListIcon>
							<Home fontSize="small" />
						</CustomListIcon>
						<Typography variant="body2">Overview</Typography>
					</MenuItem>
					{selectedClient && selectedTopic ? (
						<>
							{clientsWithReport.includes(selectedClient.clientId) &&
							clientsWithReport.includes(user.clientId) ? (
								<MenuItem onClick={() => navigate(routes.report)}>
									<CustomListIcon>
										<BarChartIcon fontSize="small" />
									</CustomListIcon>
									<Typography variant="body2">Report</Typography>
								</MenuItem>
							) : null}

							{user?.role === UserRole.ADMIN ||
							userWithClients.globalRole === GlobalUserRole.ADMIN ? (
								<MenuItem onClick={() => navigate(routes.admin)}>
									<CustomListIcon>
										<AdminPanelSettings fontSize="small" />
									</CustomListIcon>
									<Typography variant="body2">Admin</Typography>
								</MenuItem>
							) : null}
						</>
					) : null}
					<SignOutItem />
					<GoogleTranslate />
				</div>
			) : (
				<>Unauthenticated</>
			)}
		</div>
	);
};

export default ExpandedNavItems;
